module.exports = __webpack_public_path__ + "media/images/logo-xs-b3e2ddc22ed2ba5c3a6b789a55bea99b.jpg";